<template>
  <div id="layout-default" class="container-fluid p-0">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <div>
          <button class="btn btn-dark sidemenu-toggler" @click="sidebarExpand = !sidebarExpand">
            <i class="fa-solid fa-caret-left me-1" v-if="sidebarExpand" />
            <i class="fa-solid fa-list" />
            <i class="fa-solid fa-caret-right ms-1" v-if="!sidebarExpand" />
          </button>
          <router-link class="navbar-brand" to="/">
            <img src="@/assets/jkr-logo.png" class="logo" />
          </router-link>
        </div>
        <div class="dropdown user-nav-dropdown">
          <button class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            <span>{{ user ? Helper.userInitial(user) : "" }}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <div class="dropdown-item text-light">
              <i class="fa-solid fa-user-circle me-1"></i>
              {{ user && user.name }}
            </div>
            <template v-for="route in filteredRoutes(dropdownRoutes)">
              <div class="dropdown-divider"></div>
              <router-link class="dropdown-item" :to="route.path">
                <i class="menu-icon me-1" :class="route.meta.icon || 'fa-solid fa-hashtag'" />
                {{ route.meta.title || route.meta.name }}
              </router-link>
            </template>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" @click="doLogout()">
              <i class="fa-solid fa-arrow-right-from-bracket me-1"></i>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="content" :class="{ expand: sidebarExpand }">
      <div class="left">
        <navbar :selected-year="selectedYear" :sidebar-expand="sidebarExpand" />
      </div>
      <div class="right">
        <div class="lead px-4 py-3 fw-medium text-light d-flex justify-content-between align-items-center flex-nowrap">
          <div class="d-flex">
            <button v-if="$route.meta.hasBackNavigation" class="btn btn-sm btn-secondary px-3 rounded-3 me-3"
              @click="$router.back()">
              <i class="fa-solid fa-arrow-left me-1" />
              Back
            </button>
            <div class="d-flex justify-content-start align-items-center" v-html="pageTitle"></div>
          </div>

          <select class="form-select form-select-sm me-auto ms-2" style="width: 100px" v-model="selectedYear"
            v-if="$route.name &&
              !$route.name.startsWith('pavement.') &&
              $route.name !== 'case-details' &&
              $route.name !== 'pavement-details'">
            <option disabled>--Select year</option>
            <option v-for="year in Helper.filterYears" :value="year">
              {{ year }}
            </option>
          </select>

          <button class="btn btn-sm btn-primary px-3 rounded-3 text-nowrap"
            v-if="$route.name && $route.name.startsWith('cases.')" @click="addNewCase()">
            <i class="fa-solid fa-plus" />
            <span class="d-none d-md-inline ms-1">Add new case</span>
          </button>
          <div class="d-flex" v-if="
            $route.name &&
            $route.name.startsWith('pavement.') &&
            $route.name !== 'pavement.summary'
          ">
            <div class="input-group input-group-sm me-2 text-nowrap" style="width: 200px">
              <input class="form-control" type="search" v-model="searchKeyword" placeholder="Search Serial No."
                @keyup.enter="searchEnter()" />
              <button class="btn btn-outline-secondary" type="button" @click="searchEnter()">
                <i class="fas fa-search" />
              </button>
            </div>

            <button class="btn btn-sm btn-primary px-3 rounded-3 text-nowrap" @click="addNewPavement()">
              <i class="fa-solid fa-plus me-1" />
              Add pavement case
            </button>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <div class="px-4 py-3 right-content">
          <router-view ref="slotContent" :selected-year="selectedYear" />
        </div>
      </div>
    </div>

    <add-new-case-modal :show="showAddNewCaseModal" @close="closeAddNewCaseModal" />

    <add-new-pavement-modal :show="showAddNewPavementModal" @close="closeAddNewPavementModal" />
  </div>
</template>

<script>
import AddNewCaseModal from "@/components/AddNewCaseModal";
import AddNewPavementModal from "@/components/AddNewPavementModal";
import Swal from "sweetalert2";
import Navbar from "@/components/Navbar";

export default {
  name: "layout-default",
  components: {
    Navbar,
    AddNewCaseModal,
    AddNewPavementModal,
  },
  data() {
    return {
      user: null,
      showAddNewCaseModal: null,
      showAddNewPavementModal: null,
      sidebarExpand: true,
      tooltipElements: [],
      pageTitle: null,
      searchKeyword: null,
      selectedYear: this.Helper.currentYear,
      dropdownRoutes: []
    };
  },
  watch: {
    "$route.name": {
      handler() {
        if (window.innerWidth < 767) {
          this.sidebarExpand = false;
        }

        const parentPageName =
          this.$route.name && this.$route.name.split(".")[0];

        const parentPageObject = this.$route.matched.find(
          (route) => route.meta && route.name == parentPageName
        );

        if (
          this.$route.matched.length > 1 &&
          parentPageObject &&
          parentPageObject.meta.title
        ) {
          this.pageTitle =
            `<span class="badge bg-secondary me-3">${parentPageObject.meta.title}</span>` +
            this.$route.meta.title;
        } else {
          this.pageTitle = this.$route.meta.title;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    filteredRoutes(routes) {
      return routes.filter(
        (r) =>
          !r.meta ||
          !r.meta.hideFor ||
          !r.meta.hideFor.includes(this.user && this.user.role)
      );
    },
    searchEnter() {
      this.$refs.slotContent.searchSerial = this.searchKeyword;
    },
    closeAddNewCaseModal(e) {
      this.showAddNewCaseModal = false;

      if (e) {
        this.$refs.slotContent.getNod();
      }
    },
    addNewCase() {
      this.showAddNewCaseModal = true;
    },
    closeAddNewPavementModal(e) {
      this.showAddNewPavementModal = false;

      if (e) {
        this.$refs.slotContent.getCases();
      }
    },
    addNewPavement() {
      this.showAddNewPavementModal = true;
    },
    doLogout() {
      Swal.fire({
        icon: "question",
        title: "<h5>Are you sure you want to logout?</h5>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.clear();

          this.$nextTick(() => {
            this.$router.push({ name: "login" });
          });
        }
      });
    },
  },
  mounted() {
    const _user = localStorage.getItem("user");

    if (_user) {
      this.user = JSON.parse(_user);
    }

    this.dropdownRoutes = this.$router.options.routes.filter((route) => route.meta && route.meta.includeInDropdown);
  },
};
</script>